var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8C24 8.55228 23.5523 9 23 9H21C20.4477 9 20 8.55228 20 8C20 7.44772 20.4477 7 21 7H23C23.5523 7 24 7.44772 24 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4 8.55228 3.55228 9 3 9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H3C3.55228 7 4 7.44772 4 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1225 3.96581C23.2655 4.49927 22.9489 5.04761 22.4154 5.19055L20.4836 5.70819C19.9501 5.85113 19.4018 5.53455 19.2588 5.00108C19.1159 4.46762 19.4325 3.91928 19.9659 3.77634L21.8978 3.2587C22.4312 3.11576 22.9796 3.43234 23.1225 3.96581Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75479 5.0012C4.61184 5.53467 4.06351 5.85125 3.53004 5.70831L1.59819 5.19067C1.06472 5.04773 0.748141 4.49939 0.891083 3.96593C1.03403 3.43246 1.58236 3.11588 2.11583 3.25882L4.04768 3.77646C4.58115 3.9194 4.89773 4.46774 4.75479 5.0012Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82272 10.9658C4.96566 11.4993 4.64908 12.0476 4.11561 12.1906L2.18376 12.7082C1.65029 12.8511 1.10196 12.5345 0.959014 12.0011C0.816073 11.4676 1.13266 10.9193 1.66612 10.7763L3.59797 10.2587C4.13144 10.1158 4.67978 10.4323 4.82272 10.9658Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1225 12.0012C22.9795 12.5347 22.4312 12.8513 21.8977 12.7083L19.9659 12.1907C19.4324 12.0477 19.1158 11.4994 19.2588 10.9659C19.4017 10.4325 19.95 10.1159 20.4835 10.2588L22.4154 10.7765C22.9488 10.9194 23.2654 11.4677 23.1225 12.0012Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94035 4.67591C8.15449 5.09488 7.88235 5.57668 7.88235 6.04551V16.1593H16.1176V6.04551C16.1176 5.57668 15.8455 5.09488 15.0597 4.67591C14.2779 4.25914 13.1671 4.02276 12 4.02276C10.8329 4.02276 9.72211 4.25914 8.94035 4.67591ZM15.8962 2.86391C17.0074 3.45632 18 4.49159 18 6.04551V18H6V6.04551C6 4.49159 6.99257 3.45632 8.10377 2.86391C9.21907 2.26931 10.6377 2 12 2C13.3623 2 14.7809 2.26931 15.8962 2.86391Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.7341C11.3009 7.7341 10.7341 8.30087 10.7341 9C10.7341 9.69914 11.3009 10.2659 12 10.2659C12.6991 10.2659 13.2659 9.69914 13.2659 9C13.2659 8.30087 12.6991 7.7341 12 7.7341ZM9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11.72V17.32H11V11.72H13Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16C3.44772 16 3 16.4477 3 17V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V17C21 16.4477 20.5523 16 20 16H4ZM19 18H5V20H19V18Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrobe);
export default __webpack_public_path__ + "static/media/strobe.56de3495cd89f76db9bbb0535b3f5805.svg";
export { ForwardRef as ReactComponent };